var _path, _ellipse, _path2, _ellipse2, _path3, _ellipse3, _path4, _ellipse4, _path5, _rect, _path6, _rect2, _rect3, _rect4, _rect5, _path7, _rect6, _rect7, _rect8, _rect9, _path8, _rect10, _rect11, _rect12, _rect13, _path9, _rect14, _rect15, _rect16, _path10, _path11, _rect17, _rect18, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCongrats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 276,
    viewBox: "0 0 225 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.519 75.0077C160.519 75.0077 162.881 80.719 160.427 83.8312C157.621 87.3916 151.021 86.6033 146.868 89.6347C140.449 94.3214 138.011 98.6487 139.714 104.646C141.756 111.837 155.895 111.686 160.069 118.514C163.733 124.508 160.95 134.929 160.95 134.929",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 19.5,
    ry: 23.5,
    transform: "matrix(-1 0 0 1 158.521 51.5)",
    fill: "#F37097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5185 57.0077C92.5185 57.0077 99.4532 61.3879 97 64.5C94.1934 68.0604 83.0207 68.6034 78.8683 71.6347C72.4485 76.3214 90.3659 80.5029 92.069 86.5C94.1112 93.6911 92.8263 96.672 97 103.5C100.664 109.494 92.9496 116.929 92.9496 116.929",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 24,
    ry: 28.5,
    transform: "matrix(-1 0 0 1 93 28.5)",
    fill: "#4B73C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.502 152.008C201.502 152.008 199.14 157.719 201.593 160.831C204.4 164.392 211 163.603 215.152 166.635C221.572 171.321 224.01 175.649 222.307 181.646C220.265 188.837 206.126 188.686 201.952 195.514C198.288 201.508 201.071 211.929 201.071 211.929",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.5,
    cy: 128.5,
    rx: 19.5,
    ry: 23.5,
    fill: "#F96C30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1044 112.635C36.1044 112.635 37.9271 120.525 36.1044 124.849C34.0191 129.794 27.0939 129.982 23.5153 134.507C17.9825 141.501 44.859 140.265 47.9245 147.453C51.6004 156.073 37.6152 160.447 43.3914 168.234C48.4619 175.07 55.6091 191.285 55.6091 191.285",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 19.5,
    ry: 23.5,
    transform: "matrix(1 0 0 -1 34.4945 91.1337)",
    fill: "#BCBBF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.672 218.175C150.672 243.48 130.733 248.48 109.199 248.237C88.0308 247.998 69.9899 245.763 69.9899 218.175C69.9899 190.586 84.1347 170.219 109.199 170.219C134.263 170.219 150.672 190.586 150.672 218.175Z",
    fill: "#FEFFFE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 132.242,
    y: 216.871,
    width: 26.5516,
    height: 46.5799,
    transform: "rotate(-123.683 132.242 216.871)",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.527 167.903C163.548 163.792 171.791 165.626 175.5 171.903V171.903V171.903C179.895 177.494 178.641 185.637 172.768 189.647L166.641 193.831L151.669 171.903L157.527 167.903Z",
    fill: "#262626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.822,
    y: 172.682,
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "rotate(-123.683 167.822 172.682)",
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170.822,
    y: 176.682,
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "rotate(-123.683 170.822 176.682)",
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 173.822,
    y: 181.682,
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "rotate(-123.683 173.822 181.682)",
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5516,
    height: 46.5799,
    transform: "matrix(0.554599 -0.832117 -0.832117 -0.554599 89.8984 217.871)",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.613 168.903C58.5918 164.792 50.3492 166.626 46.6401 172.903V172.903V172.903C42.2456 178.494 43.4994 186.637 49.3724 190.647L55.4987 194.831L70.4712 172.903L64.613 168.903Z",
    fill: "#262626"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "matrix(0.554599 -0.832117 -0.832117 -0.554599 54.318 173.682)",
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "matrix(0.554599 -0.832117 -0.832117 -0.554599 51.318 177.682)",
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "matrix(0.554599 -0.832117 -0.832117 -0.554599 48.3179 182.682)",
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5516,
    height: 46.5799,
    transform: "matrix(-0.999423 -0.0339564 -0.0339564 0.999423 99.967 213.924)",
    fill: "#4186EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6216 261.187C71.2923 268.471 77.1883 274.516 84.4778 274.368V274.368V274.368C91.5446 275.165 97.8102 269.815 98.1314 262.711L98.4665 255.3L71.9421 254.101L71.6216 261.187Z",
    fill: "#262626"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "matrix(-0.999423 -0.0339565 -0.0339565 0.999423 81.1013 267.429)",
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "matrix(-0.999423 -0.0339565 -0.0339565 0.999423 86.0813 267.876)",
    fill: "#C4C4C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "matrix(-0.999423 -0.0339565 -0.0339565 0.999423 91.9117 267.798)",
    fill: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 120.006,
    y: 212.924,
    width: 26.5516,
    height: 46.5799,
    transform: "rotate(-1.94594 120.006 212.924)",
    fill: "#4186EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.352 260.187C148.681 267.471 142.785 273.516 135.496 273.368V273.368V273.368C128.429 274.165 122.163 268.815 121.842 261.711L121.507 254.3L148.031 253.101L148.352 260.187Z",
    fill: "#262626"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 138.872,
    y: 266.429,
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "rotate(-1.94594 138.872 266.429)",
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 133.892,
    y: 266.876,
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "rotate(-1.94594 133.892 266.876)",
    fill: "#C4C4C4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 128.062,
    y: 266.798,
    width: 3.28558,
    height: 6.51311,
    rx: 1.64279,
    transform: "rotate(-1.94594 128.062 266.798)",
    fill: "#C4C4C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.393 218.218C151.393 239.868 131.402 248.763 109.812 248.555C88.5889 248.35 67.6121 241.822 67.6121 218.218C71.2233 171.119 84.6826 175.735 109.812 175.735C134.941 175.735 151.393 171.119 151.393 218.218Z",
    fill: "#6FCF97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.393 223.325C151.393 241.331 131.402 248.728 109.812 248.555C88.5889 248.385 67.6121 242.956 67.6121 223.325C71.2233 184.153 84.6826 187.993 109.812 187.993C134.941 187.993 151.393 184.153 151.393 223.325Z",
    fill: "#4186EE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 131.616,
    y: 173.445,
    width: 15.8894,
    height: 22.3896,
    rx: 7.94471,
    transform: "rotate(26.0604 131.616 173.445)",
    fill: "#4186EE"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 15.8894,
    height: 22.3896,
    rx: 7.94471,
    transform: "matrix(-0.898332 0.439318 0.439318 0.898332 89.109 174.889)",
    fill: "#4186EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.287 114.558C161.237 107.364 159.514 97.3842 152.439 92.2665V92.2665C145.365 87.1487 135.617 88.8313 130.667 96.0246L102.618 136.788L128.238 155.321L156.287 114.558Z",
    fill: "#262626"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9618 114.558C58.0121 107.364 59.7348 97.3842 66.8095 92.2665V92.2665C73.8843 87.1487 83.6321 88.8313 88.5819 96.0246L116.631 136.788L91.0112 155.321L62.9618 114.558Z",
    fill: "#262626"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.488 144.046C157.488 171.79 134.022 176 109.439 176C84.8565 176 62.8646 171.79 62.8646 144.046C62.8646 116.303 84.8565 93.8118 109.439 93.8118C134.022 93.8118 157.488 116.303 157.488 144.046Z",
    fill: "#FEFFFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4751 128.155C79.4751 121.764 84.6558 116.583 91.0464 116.583V116.583C97.4371 116.583 102.618 121.764 102.618 128.155V132.185C102.618 138.576 97.4371 143.756 91.0464 143.756V143.756C84.6558 143.756 79.4751 138.576 79.4751 132.185V128.155Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4751 128.155C79.4751 121.764 84.6558 116.583 91.0464 116.583V116.583C97.4371 116.583 102.618 121.764 102.618 128.155V132.185C102.618 138.576 97.4371 143.756 91.0464 143.756V143.756C84.6558 143.756 79.4751 138.576 79.4751 132.185V128.155Z",
    fill: "#C4C4C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.682 128.155C115.682 121.764 120.863 116.583 127.253 116.583V116.583C133.644 116.583 138.825 121.764 138.825 128.155V132.185C138.825 138.576 133.644 143.756 127.253 143.756V143.756C120.863 143.756 115.682 138.576 115.682 132.185V128.155Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.682 128.155C115.682 121.764 120.863 116.583 127.253 116.583V116.583C133.644 116.583 138.825 121.764 138.825 128.155V132.185C138.825 138.576 133.644 143.756 127.253 143.756V143.756C120.863 143.756 115.682 138.576 115.682 132.185V128.155Z",
    fill: "#C4C4C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6075 130.007C84.6075 126.451 87.4903 123.568 91.0464 123.568V123.568C94.6025 123.568 97.4853 126.451 97.4853 130.007V130.333C97.4853 133.889 94.6025 136.772 91.0464 136.772V136.772C87.4903 136.772 84.6075 133.889 84.6075 130.333V130.007Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6075 130.007C84.6075 126.451 87.4903 123.568 91.0464 123.568V123.568C94.6025 123.568 97.4853 126.451 97.4853 130.007V130.333C97.4853 133.889 94.6025 136.772 91.0464 136.772V136.772C87.4903 136.772 84.6075 133.889 84.6075 130.333V130.007Z",
    fill: "#151414"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.591 147.488C101.591 143.842 104.547 140.886 108.193 140.886H112.067C115.713 140.886 118.668 143.842 118.668 147.488V147.488C118.668 151.134 115.713 154.09 112.067 154.09H108.193C104.547 154.09 101.591 151.134 101.591 147.488V147.488Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M101.591 147.488C101.591 143.842 104.547 140.886 108.193 140.886H112.067C115.713 140.886 118.668 143.842 118.668 147.488V147.488C118.668 151.134 115.713 154.09 112.067 154.09H108.193C104.547 154.09 101.591 151.134 101.591 147.488V147.488Z",
    fill: "#262626"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.815 130.007C120.815 126.451 123.697 123.568 127.253 123.568V123.568C130.81 123.568 133.692 126.451 133.692 130.007V130.333C133.692 133.889 130.81 136.772 127.253 136.772V136.772C123.697 136.772 120.815 133.889 120.815 130.333V130.007Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.815 130.007C120.815 126.451 123.697 123.568 127.253 123.568V123.568C130.81 123.568 133.692 126.451 133.692 130.007V130.333C133.692 133.889 130.81 136.772 127.253 136.772V136.772C123.697 136.772 120.815 133.889 120.815 130.333V130.007Z",
    fill: "#151414"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12L28.1638 27.5471H44.8743L31.3552 37.1558L36.5191 52.7029L23 43.0942L9.48094 52.7029L14.6448 37.1558L1.1257 27.5471H17.8362L23 12Z",
    fill: "#FAD462"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M129 47L132.817 58.4012H145.168L135.176 65.4476L138.992 76.8488L129 69.8024L119.008 76.8488L122.824 65.4476L112.832 58.4012H125.183L129 47Z",
    fill: "#FAD462"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23 196L26.8167 207.401H39.168L29.1756 214.448L32.9923 225.849L23 218.802L13.0077 225.849L16.8244 214.448L6.83204 207.401H19.1833L23 196Z",
    fill: "#FAD462"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 132L195.878 146.165H210.046L198.584 154.92L202.962 169.085L191.5 160.33L180.038 169.085L184.416 154.92L172.954 146.165H187.122L191.5 132Z",
    fill: "#FAD462"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.8b4b7804.svg";
export { ForwardRef as ReactComponent };